const layers = [
  {
    "type": "overlayers",
    "name": "Sobreposições",
    "visible": true,
    "layers": [
      {
        "id": 733,
        "type": "overlayer",
        "name": "Ponto de captação e bacia de manancial",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:group_sia",
          "STYLES": "pgw-group_sia",
          "SRS": "EPSG:4326",
          "VIEWPARAMS": "locationid:1162",
          "ENV": "circle_fill_color:3eca8f;polygon_fill_color:b1ebce;polygon_fill_opacity:0.8;polygon_stroke_color:58d09a"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.9,
          "visible": true,
          "zindex": 0
        },
        "hide_on_menu": true,
      },
      {
        "id": 739,
        "type": "overlayer",
        "name": "Pontos de captação",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:pontocaptacao",
          "STYLES": "pgw-sia-catchment_point",
          "ENV": "circle_fill_color:7AC1FF"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "cptsia",
            "citname",
            "sistema",
            "cptnome" */
            '{"key": "cptsia,citname,sistema,cptnome", "label_title": "SIA"}',
          ],
          "FORMAT": "SIA {0} - {1} - {2} - {3}"
        },
        "event_params": {
          "type": "click",
        },
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 2
        },
        "icon_params": {
          "class": "icon-infohidro-pontos-captacao",
          "background_color": "#7AC1FF"
        },
      },
      {
        "id": 622,
        "name": "Bacias de mananciais",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:mananciais_sanepar",
          "STYLES": "pgw_polygon_env",
          "ENV": "stroke_color:0583F2;fill_color:FFF;stroke_width:1;fill_opacity:0.15"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "sbsname", "label_title": ""}',
            '{"key": "sbsobs", "property_child": "Q95", "label": "Q95", "suffix": ""}',
            '{"key": "sbsobs", "property_child": "area", "label": "Área", "suffix": "", "decimal_number": 1}',
          ],
          "FORMAT": "{0}<br>{1}<br>{2}",
          "icon_params":{
            "class": "icon-infohidro-bacia",
            "background_color": "#0071B0"
          },
        },
        "event_params": {
          "type": "click",
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 1,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(101, 156, 213, 0.5)',
            "strokeColor": '#659CD5'
          },
        }
      },
      {
        "id": 664,
        "type": "overlayer",
        "name": "Futuras bacias de captação",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:mananciais_futuro",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:023373;stroke_color:023373"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 1,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(2, 51[[]], 115, 0.6)',
            "strokeColor": '#023373',
          },
        }
      },
      {
        id: 710,
        name: 'Desmatamentos',
        url: 'https://produtos.simepar.br/geosimepar/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:alertas_desmatamento',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: 'sanepar:infohidro-polygon_env',
          ENV: 'fill_color:EA1717;fill_opacity:0.9;stroke_color:EA1717',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        tooltip_params: {
          KEYS: ['{"key": "DATADETEC", "label": "Data de detecção", "icon_label": "circle"}',
            '{"key": "AREAHA", "label": "Área", "icon_label": "circle"}',
            '{"key": "VPRESSAO", "label": "Pressão", "icon_label": "circle"}',
            '{"key": "FONTE", "label": "Fonte", "icon_label": "circle"}',
            '{"key": "OGC_FID", "label": "Código", "icon_label": "circle"}',
            '{"key": "MUNICIPIO", "label": "Município", "icon_label": "circle"}',
          ],
        },
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Alertas de Desmatamento', color: '#EA1717', style: 'circle' },

              ],
            },
          ],
        },
      },
      {
        "id": 749,
        "type": "animation",
        "name": "Evolução do uso e cobertura da terra",
        "url": "https://produtos.simepar.br/geoserver/sanepar/wms?dim_year=1985",
        "url_params": {
          "LAYERS": "sanepar:mapbiomas",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
        },
        "url_caption_params": {
          "LAYER": "sanepar:mapbiomas",
          "LEGEND_OPTIONS": "fontAntiAliasing:true;fontColor:0x000033;fontSize:6;bgColor:0xF0F0F0;dpi:180;dx:5&transparent=true"
        },
        "animation_type": "image_mosaic",
        "server": "geoserver",
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        params: {
          "image_mosaic": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geoserver/db/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=db%3Amapbiomas&outputFormat=application%2Fjson&propertyName=year&sortby=year+d",
            "FEATURE_INFO_VALUE": "GRAY_INDEX",
            "TITLE_DATETIME_FORMAT": "YYYY",
            "TIME_FEATURE_PROPERTY": "year"
          }
        },
        caption_html: {
          alwaysVisible: false,
          vertical: true,
          groupItems: [
            {
              text: "Cobertura Florestal",
              items: [
                { text: 'Formação Florestal', color: '#18812A', style: 'square' },
                { text: 'Formação Savânica', color: '#53A313', style: 'square' },
                { text: 'Mangue', color: '#C46A40', style: 'square' },
                { text: 'Restinga Arborizada', color: '#91AA34', style: 'square' },
              ]
            },
            {
              text: "Formação Natural não Florestal",
              items: [
                { text: 'Campo Alagado e Área Pantanosa', color: '#4AC780', style: 'square' },
                { text: 'Formação Campestre', color: '#45B074', style: 'square' },
                { text: 'Apicum', color: '#3E9355', style: 'square' },
                { text: 'Afloramento Rochoso', color: '#AEBBB1', style: 'square' },
                { text: 'Outras Formações não Florestais', color: '#F1C232', style: 'square' },
              ]
            },
            {
              text: "Agropecuária",
              items: [
                { text: 'Pastagem', color: '#EFAF4E', style: 'square' },
                { text: 'Agricultura', color: '#E57142', style: 'square' },
                { text: 'Lavoura Temporária', color: '#E25249', style: 'square' },
                { text: 'Soja', color: '#C59FF4', style: 'square' },
                { text: 'Cana', color: '#C27BA0', style: 'square' },
                { text: 'Arroz', color: '#982C9E', style: 'square' },
                { text: 'Outras Lavouras Temporárias', color: '#E787F8', style: 'square' },
                { text: 'Lavoura Perene', color: '#F3B4F1', style: 'square' },
                { text: 'Café', color: '#CCA0D4', style: 'square' },
                { text: 'Citrus', color: '#D082DE', style: 'square' },
                { text: 'Outras Lavoura Perene', color: '#CD49E4', style: 'square' },
                { text: 'Silvicultura', color: '#D5622C', style: 'square' },
                { text: 'Mosaico de Agricultura e Pastagem', color: '#FFD1BE', style: 'square' }
              ]
            },
            {
              text: "Área não vegetada",
              items: [
                { text: 'Praia, Duna e Areal', color: '#FBE051', style: 'square' },
                { text: 'Área Urbanizada', color: '#AA0000', style: 'square' },
                { text: 'Mineração', color: '#F34A4A', style: 'square' },
                { text: 'Outras Áreas não Vegetadas', color: '#E58088', style: 'square' },
              ]
            },
            {
              text: "Corpos D'água",
              items: [
                { text: 'Rio, Lago e Oceano', color: '#4F7EDB', style: 'square' },
                { text: 'Aquicultura', color: '#2D54A0', style: 'square' },
              ]
            },
          ]
        },
      },
      {
        "id": 660,
        "type": "overlayer",
        "name": "Índice de vegetação",
        "url": window.location.origin + "/geosimepar/tiff/wms?",
        "url_params": {
          "layers": "tiff:MODIS_Aqua_L3_NDVI_16Day_br",
          "Format": "image/png"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 1
        }
      },
      {
        "id": 688,
        "type": "overlayer",
        "name": "Focos de calor",
        "url": "https://produtos.simepar.br/geosimepar/tornado/wms?",
        "url_params": {
          "LAYERS": "tornado:fococalor",
          "STYLES": "pgw-point_heatfocus"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "datahora", "label": "Horário de detecção", "icon_label":"mdi-arrow-right-drop-circle-outline", "dateFormat": "DD/MM/YYYY [às] HH:mm"}',
            '{"key": "satelite", "label": "Satélite", "icon_label":"mdi-broadcast"}',
            '{"key": "fonte", "label": "Fonte", "icon_label":"mdi-magnify"}',
          ],
          "FORMAT": "{0}<br>Fonte: {1} / {2}",
          "DECIMAL_PRECISION": [
            "",
            "",
            ""
          ]
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        },
        "icon_params": {
          "class": "icon-infohidro-fogo",
          "background_color": "#FFB740"
        },
      },
      {
        "id": 729,
        "type": "overlayer",
        "name": "Risco de incêndio",
        "url": "https://produtos.simepar.br/geosimepar/tiff/wms?",
        "url_params": {
          "LAYERS": "tiff:fma",
          "STYLES": "infohidro-fire_risk"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          alwaysVisible: false,
          vertical: true,
          items: [
            { text: 'Nulo', color: '#038C33', style: 'square' },
            { text: 'Baixo', color: '#2BD925', style: 'square' },
            { text: 'Médio', color: '#EBEA00', style: 'square' },
            { text: 'Alto', color: '#F27405', style: 'square' },
            { text: 'Muito alto', color: '#F20505', style: 'square' },
          ]
        }
      },
    ]
  },

  {
    "type": "satellite_grouping_player",
    "name": "Imagens de satélites dos reservatórios",
    "visible": true,
    "layers": [
      {
        "id": 750,
        "name": "Iraí - 1Band S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "1bnd",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%271bnd%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 752,
        "name": "Iraí - 4Band S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai4b",
          "SRS": "EPSG:4326",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "animation_type": "IMAGE_MOSAIC",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai4b&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%274bnd%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "ALPHA_BAND",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 751,
        "name": "Iraí - NDVI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndvi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndvi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 753,
        "name": "Iraí - NDWI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndwi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndwi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 754,
        "name": "Passaúna - 1Band S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "1bnd",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%271bnd%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 755,
        "name": "Passaúna - 4Band S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna4b",
          "SRS": "EPSG:4326",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0,
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna4b&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%274bnd%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "ALPHA_BAND",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 756,
        "name": "Passaúna - NDVI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndvi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndvi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 757,
        "name": "Passaúna - NDWI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndwi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndwi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 758,
        "name": "Piraquara I e II - 1Band S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "1bnd",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%271bnd%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 759,
        "name": "Piraquara I e II - 4Band S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras4b",
          "SRS": "EPSG:4326",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ],
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0,
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras4b&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%274bnd%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 760,
        "name": "Piraquara I e II - NDVI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndvi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndvi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 761,
        "name": "Piraquara I e II - NDWI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndwi",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndwi%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      }
    ]
  },

  {
    "type": "grouping",
    "name": "Unidades de conservação",
    "visible": true,
    "layers": [
      {
        "id": 762,
        "name": "Municipais",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:unidadeconservacao",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:044D29;stroke_color:044D29;fill_opacity:0.8",
          "cql_filter": "uncadministracao='Municipal'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /*  "uncnome", */
            '{"key": "uncnome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 763,
        "name": "Estaduais",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:unidadeconservacao",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:007c2d;stroke_color:007c2d;fill_opacity:0.8",
          "cql_filter": "uncadministracao='Estadual'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /*  "uncnome", */
            '{"key": "uncnome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 764,
        "name": "Estaduais/Distritais",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:unidadeconservacao",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:009e4c;stroke_color:009e4c;fill_opacity:0.8",
          "cql_filter": "uncadministracao='Estadual/Distrital'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /*  "uncnome", */
            '{"key": "uncnome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 765,
        "name": "Federais",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:unidadeconservacao",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:62d1af;stroke_color:62d1af;fill_opacity:0.8",
          "cql_filter": "uncadministracao='Federal'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /*  "uncnome", */
            '{"key": "uncnome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(22, 128, 57, 0.5)',
            "strokeColor": '#044D29'
          },
        }
      },
      {
        "id": 766,
        "name": "Desconhecidas",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:unidadeconservacao",
          "STYLES": "pgw-polygon_env",
          "env": "fill_color:b3e6e5;stroke_color:b3e6e5;fill_opacity:0.8",
          "cql_filter": "uncadministracao='Desconhecida'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /*  "uncnome", */
            '{"key": "uncnome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      }
    ]
  },
  {
    "type": "grouping",
    "name": "Hidrografia",
    "visible": true,
    "layers": [
      {
        "id": 695,
        "name": "Rios de captação",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipalcaptacao",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:0583F2"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "rpcname" */
            '{"key": "rpcname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 696,
        "name": "Rios de lançamentos de efluentes",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipallancamento",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:E17536"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "rplname" */
            '{"key": "rplname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 683,
        "name": "Hidrografia do Paraná",
        "url": "https://produtos.simepar.br/geosimepar/shape/wms?",
        "url_params": {
          "LAYERS": "shape:hidrografia_iat"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "nooriginal", */
            '{"key": "nooriginal", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 748,
        "name": "Grandes bacias do Paraná",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:bacias_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:023373;stroke_color:023373;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "nome_bh", */
            '{"key": "nome_bh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(2, 51, 115, 0.6)',
            "strokeColor": '#023373',
          },
        }
      },
      {
        "id": 747,
        "name": "Unidades hidrográficas oficiais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:unidades_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:0583F2;stroke_color:0583F2;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "nome_uh", */
            '{"key": "nome_uh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(5, 131, 242, 0.6)',
            "strokeColor": '#0583F2',
          },
        }
      },
      {
        "id": 767,
        "name": "Aquíferos",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:aquiferoaflorante"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "saanome",
            "saatipo", */
            '{"key": "saanome", "label_title": ""}',
            '{"key": "saatipo", "label": "Tipo", "icon_label":"mdi-texture-box"}',
          ],
          "FORMAT": "{0} ({1})"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          alwaysVisible: false,
          vertical: true,
          groupItems: [
            {
              text: "Cárstico",
              items: [
                { text: 'Carste da Bacia do Paraná', color: '#F2AB43', style: 'square' },
              ]
            },
            {
              text: "Fraturado",
              items: [
                { text: 'Fraturado Centro-Sul', color: '#C0FF43', style: 'square' },
                { text: 'Serra Geral', color: '#79BA43', style: 'square' },
              ]
            },
            {
              text: "Poroso",
              items: [
                { text: 'Alexandra - Guaraqueçaba', color: '#96E6FE', style: 'square' },
                { text: 'Bateias - Campo Alegre', color: '#8EDEF8', style: 'square' },
                { text: 'Bauru-Caiuá', color: '#8CDAF6', style: 'square' },
                { text: 'Cananéia', color: '#82CFF0', style: 'square' },
                { text: 'Castro', color: '#80CDEE', style: 'square' },
                { text: 'Ervalzinho', color: '#77C1E7', style: 'square' },
                { text: 'Furnas', color: '#76BCE3', style: 'square' },
                { text: 'Guabirotuba', color: '#72B8E1', style: 'square' },
                { text: 'Guarani', color: '#74BBE3', style: 'square' },
                { text: 'Itararé', color: '#6CB2DD', style: 'square' },
                { text: 'Palermo', color: '#5EA1D2', style: 'square' },
                { text: 'Passa Dois', color: '#5A9BCE', style: 'square' },
                { text: 'Ponta Grossa', color: '#5592CB', style: 'square' },
                { text: 'Rio Bonito', color: '#508FC8', style: 'square' },
                { text: 'Litorâneo Nordeste - Sudeste', color: '#436EB0', style: 'square' },
              ]
            },
          ]
        },
      }
    ]
  },
  {
    "type": "grouping",
    "name": "Reserva particular de patrimônio natural (RPPN)",
    "visible": true,
    "layers": [
      {
        "id": 665,
        "name": "Municipais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:RPPNs_Municipais"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "Nome", */
            '{"key": "nome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        }
      },
      {
        "id": 666,
        "name": "Estaduais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:RPPNs_Estadual"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "Nome", */
            '{"key": "Nome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        }
      },
      {
        "id": 667,
        "name": "Federais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:RPPNs_Federal"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "Nome" */
            '{"key": "Nome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        }
      }
    ]
  },
  {
    "type": "grouping",
    "name": "Áreas urbanas e rurais",
    "visible": true,
    "layers": [
      {
        "id": 775,
        "name": "Sedes municipais",
        "url": "https://produtos.simepar.br/geosimepar/tornado/wms?",
        "url_params": {
          "LAYERS": "tornado:sedemunicipalgeo",
          "STYLES": "pgw-point_building",
          "CQL_FILTER": "seduf='PARANA'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "nome" */
            '{"key": "nome", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 4
        },
        "icon_params": {
          "class": "icon-infohidro-predio",
          "background_color": "#FF7630"
        },
      },
      {
        "id": 773,
        "name": "Áreas urbanas",
        "url": "https://produtos.simepar.br/geosimepar/tornado/gwc/service?",
        "url_params": {
          "LAYERS": "tornado:area_urbana",
          "STYLES": "pgw_polygon_env",
          "env": "fill_color:008AD7;stroke_color:008AD7;fill_opacity:0.8",
          "cql_filter": "uf='PR'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 3,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(0, 138, 215, 0.1)',
            "strokeColor": '#008AD7',
          },
        }
      },
      {
        "id": 772,
        "name": "Áreas dos municípios",
        "url": "https://produtos.simepar.br/geosimepar/tornado/wms?",
        "url_params": {
          "LAYERS": "tornado:brasil_municipios",
          "STYLES": "pgw_polygon_env",
          "env": "fill_color:0071B0;stroke_color:0071B0;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05",
          "CQL_FILTER": "munuf='PARANA'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "munnome", */
            '{"key": "munnome", "label_title": ""}',
          ],
          "FORMAT": " {0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(0, 113, 176, 0.5)',
            "strokeColor": '#95A1EC',
          },
        }
      },
      {
        "id": 768,
        "name": "Cadastro Ambiental Rural (CAR)",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:sicarpr"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        }
      }
    ]
  },
  {
    "type": "grouping",
    "name": "Gerências",
    "visible": true,
    "layers": [
      {
        "id": 653,
        "name": "Gerais",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:gerenciageralsanepar",
          "STYLES": "pgw_polygon_env",
          "ENV": "fill_color:0071B0;stroke_color:0071B0;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "ggsdescricao", */
            '{"key": "ggsdescricao", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(0, 113, 176, 0.5)',
            "strokeColor": '#95A1EC',
          },
        }
      },
      {
        "id": 709,
        "name": "Regionais",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:gerenciaregionalsanepar",
          "STYLES": "pgw_polygon_env",
          "ENV": "fill_color:004870;stroke_color:004870;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            /* "grssigla", */
            '{"key": "grssigla", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(0, 72, 112, 0.5)',
            "strokeColor": '#004870',
          },
        }
      },
    ]
  }
];

export default layers;
